import { DataTable, FieldType } from './dataTable.js';
export class CsvToDataTable {
    convert(csv, fileTextseparator) {
        let dataTable = null;
        const fields = [];
        const lines = csv.split('\n');
        // split a CSV line while considering quotes
        function splitCSVLine(line, sep) {
            const result = [];
            let current = '';
            let inQuotes = false;
            for (const char of line) {
                if (char === '"') {
                    inQuotes = !inQuotes;
                    current += char;
                }
                else if (char === sep && !inQuotes) {
                    result.push(current);
                    current = '';
                }
                else {
                    current += char;
                }
            }
            result.push(current);
            return result;
        }
        if (lines.length > 0) {
            const headers = splitCSVLine(lines[0], fileTextseparator);
            headers.forEach((h) => {
                h = h.replaceAll('"', '');
                fields.push({ name: h.replaceAll('"', ''), alias: h.replaceAll('"', ''), type: FieldType.STRING, visible: true, originDataSort: false });
            });
            const data = [];
            for (let i = 1; i < lines.length - 1; i++) {
                const obj = {};
                const currentline = splitCSVLine(lines[i], fileTextseparator);
                for (let j = 0; j < headers.length; j++) {
                    obj[headers[j].replaceAll('"', '')] = currentline[j] ?? currentline[j].replaceAll('"', '').replaceAll(String.fromCharCode(92), '');
                }
                data.push(obj);
            }
            dataTable = new DataTable({ id: 'csv', fields, json: data });
        }
        return dataTable;
    }
}
